import { render, staticRenderFns } from "./CategoryChecklistsTransfer.vue?vue&type=template&id=33c4ac6d&scoped=true&"
import script from "./CategoryChecklistsTransfer.vue?vue&type=script&lang=js&"
export * from "./CategoryChecklistsTransfer.vue?vue&type=script&lang=js&"
import style0 from "./CategoryChecklistsTransfer.vue?vue&type=style&index=0&id=33c4ac6d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c4ac6d",
  null
  
)

export default component.exports